import { render } from "./ScanStockInNew.vue?vue&type=template&id=0c0a9387&scoped=true"
import script from "./ScanStockInNew.vue?vue&type=script&lang=js"
export * from "./ScanStockInNew.vue?vue&type=script&lang=js"

import "./ScanStockInNew.vue?vue&type=style&index=0&id=0c0a9387&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0a9387"]])

export default __exports__